<div class="analytics-performance-panel">
  <!-- Header Section - Always visible -->
  <div class="header-card" [class.expanded-view]="isFullScreen">
    <div class="header-content">
      <div class="header-top">
        <div class="title-section">
          <svg class="arrow-left" width="24" height="24" viewBox="0 0 24 24" fill="none" (click)="assetReviewClosehandle()">
            <path d="M15 12H1M1 12L8 19M1 12L8 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div class="title-group">
            <h2 class="target-title">{{ (assetReviewStoreDetails?.storeName || storeData?.targetName) }} {{ assetReviewStoreDetails?.storeNumber ? '#' + assetReviewStoreDetails.storeNumber : '' }}</h2>
          </div>
        </div>
        <div class="action-buttons">
          <div *ngIf="!isNewPage" class="expand-button" (click)="expandPanel()" matTooltip="Expand View" matTooltipClass="custom-tooltip" matTooltipPosition="above">
            <svg *ngIf="!isFullScreen" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 9L21 3M21 3H15M21 3V9M9 9L3 3M3 3L3 9M3 3L9 3M9 15L3 21M3 21H9M3 21L3 15M15 15L21 21M21 21V15M21 21H15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <img height="24" width="24" *ngIf="isFullScreen" src="assets/images/Collapse.png" alt="">
          </div>
          <div *ngIf="!isNewPage" class="external-link" (click)="openInNewPage()" matTooltip="Open in New Tab" matTooltipClass="custom-tooltip" matTooltipPosition="above">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 2H7C7.55228 2 8 2.44772 8 3C8 3.51284 7.61396 3.93551 7.11662 3.99327L7 4H5C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V19C4 19.5128 4.38604 19.9355 4.88338 19.9933L5 20H19C19.5128 20 19.9355 19.614 19.9933 19.1166L20 19V17C20 16.4477 20.4477 16 21 16C21.5128 16 21.9355 16.386 21.9933 16.8834L22 17V19C22 20.5977 20.7511 21.9037 19.1763 21.9949L19 22H5C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2ZM21 2L21.081 2.003L21.2007 2.02024L21.3121 2.04974L21.4232 2.09367L21.5207 2.146L21.6168 2.21279L21.7071 2.29289L21.8037 2.40469L21.8753 2.51594L21.9063 2.5769L21.9401 2.65835L21.9642 2.73401L21.9931 2.8819L22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.414L13.7071 11.7071C13.3466 12.0676 12.7794 12.0953 12.3871 11.7903L12.2929 11.7071C11.9324 11.3466 11.9047 10.7794 12.2097 10.3871L12.2929 10.2929L18.584 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H21Z" fill="white"/>
            </svg>
          </div>
          <!-- Dynamic Download Button -->
          <div class="download-dropdown">
            <span class="download-button" [class.dropdown-selected]="dropdownOpen" [class.disabled]="isdataLoading || hasError" (click)="!isdataLoading && toggleDropdown()" [matTooltip]="isdataLoading ? 'Please wait for data to load' : 'Download'" matTooltipClass="custom-tooltip" matTooltipPosition="above">
              <div class="download-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12.5535 17.0061C12.4114 17.1615 12.2106 17.25 12 17.25C11.7894 17.25 11.5886 17.1615 11.4465 17.0061L7.44649 12.6311C7.16699 12.3254 7.18823 11.851 7.49393 11.5715C7.79964 11.292 8.27403 11.3132 8.55353 11.6189L11.25 14.5682V3.5C11.25 3.08579 11.5858 2.75 12 2.75C12.4142 2.75 12.75 3.08579 12.75 3.5V14.5682L15.4465 11.6189C15.726 11.3132 16.2004 11.292 16.5061 11.5715C16.8118 11.851 16.833 12.3254 16.5535 12.6311L12.5535 17.0061Z" fill="white"/>
                  <path d="M3.75 15.5C3.75 15.0858 3.41422 14.75 3 14.75C2.58579 14.75 2.25 15.0858 2.25 15.5V15.5549C2.24998 16.9225 2.24996 18.0248 2.36652 18.8918C2.48754 19.7919 2.74643 20.5497 3.34835 21.1516C3.95027 21.7536 4.70814 22.0125 5.60825 22.1335C6.47522 22.25 7.57754 22.25 8.94513 22.25H15.0549C16.4225 22.25 17.5248 22.25 18.3918 22.1335C19.2919 22.0125 20.0497 21.7536 20.6517 21.1516C21.2536 20.5497 21.5125 19.7919 21.6335 18.8918C21.75 18.0248 21.75 16.9225 21.75 15.5549V15.5C21.75 15.0858 21.4142 14.75 21 14.75C20.5858 14.75 20.25 15.0858 20.25 15.5C20.25 16.9354 20.2484 17.9365 20.1469 18.6919C20.0482 19.4257 19.8678 19.8142 19.591 20.091C19.3142 20.3678 18.9257 20.5482 18.1919 20.6469C17.4365 20.7484 16.4354 20.75 15 20.75H9C7.56459 20.75 6.56347 20.7484 5.80812 20.6469C5.07435 20.5482 4.68577 20.3678 4.40901 20.091C4.13225 19.8142 3.9518 19.4257 3.85315 18.6919C3.75159 17.9365 3.75 16.9354 3.75 15.5Z" fill="white"/>
                </svg>
              </div>
              <div class="chevron" [class.open]="dropdownOpen">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline [attr.points]="dropdownOpen ? '18 15 12 9 6 15' : '6 9 12 15 18 9'" />
                </svg>
              </div>

            </span>
            <ul class="download-options" *ngIf="dropdownOpen && !isLoading">
              <li class="d-flex" (click)="download('pdf')"><img src="assets/images/pdf-icon.svg" alt="PDF"> PDF</li>
              <li class="d-flex" (click)="download('excel')"><img src="assets/images/excel-icon.svg" alt="Excel"> Excel</li>
              <li class="d-flex" (click)="download('csv')"><img src="assets/images/csv-icon.svg" alt="CSV"> CSV</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="location-info" [class.expanded]="isFullScreen">
        <div class="address-row">
          <svg class="location-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7.00065 8.08366C7.96715 8.08366 8.75065 7.30016 8.75065 6.33366C8.75065 5.36716 7.96715 4.58366 7.00065 4.58366C6.03415 4.58366 5.25065 5.36716 5.25065 6.33366C5.25065 7.30016 6.03415 8.08366 7.00065 8.08366Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.00065 13.3337C9.33398 11.0003 11.6673 8.91099 11.6673 6.33366C11.6673 3.75633 9.57798 1.66699 7.00065 1.66699C4.42332 1.66699 2.33398 3.75633 2.33398 6.33366C2.33398 8.91099 4.66732 11.0003 7.00065 13.3337Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="address-text" [class.expanded-text]="isFullScreen" >{{ (assetReviewStoreDetails?.address || 'N/A') }}</span>
        </div>
        <div class="trade-area-row">
          <svg class="target-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M6.99935 13.3337C10.221 13.3337 12.8327 10.722 12.8327 7.50033C12.8327 4.27866 10.221 1.66699 6.99935 1.66699C3.77769 1.66699 1.16602 4.27866 1.16602 7.50033C1.16602 10.722 3.77769 13.3337 6.99935 13.3337Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.99935 11.0003C8.93235 11.0003 10.4993 9.43332 10.4993 7.50033C10.4993 5.56733 8.93235 4.00033 6.99935 4.00033C5.06635 4.00033 3.49935 5.56733 3.49935 7.50033C3.49935 9.43332 5.06635 11.0003 6.99935 11.0003Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.99935 8.66699C7.64368 8.66699 8.16602 8.14466 8.16602 7.50033C8.16602 6.85599 7.64368 6.33366 6.99935 6.33366C6.35502 6.33366 5.83268 6.85599 5.83268 7.50033C5.83268 8.14466 6.35502 8.66699 6.99935 8.66699Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="trade-area-text" [class.expanded-text]="isFullScreen"> {{ (assetReviewStoreDetails?.tradeAreaName || 'N/A') }}</span>
        </div>
        <div class="report-date-row">
          <svg class="file-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M8.16732 1.82422V4.2337C8.16732 4.5604 8.16732 4.72375 8.2309 4.84853C8.28682 4.95829 8.37606 5.04753 8.48582 5.10345C8.6106 5.16703 8.77395 5.16703 9.10065 5.16703H11.5101M4.66732 9.25033V11.0003M9.33398 8.08366V11.0003M7.00065 6.62533V11.0003M11.6673 6.32679V10.5337C11.6673 11.5138 11.6673 12.0038 11.4766 12.3781C11.3088 12.7074 11.0411 12.9751 10.7118 13.1429C10.3375 13.3337 9.84741 13.3337 8.86732 13.3337H5.13398C4.15389 13.3337 3.66385 13.3337 3.2895 13.1429C2.96022 12.9751 2.6925 12.7074 2.52472 12.3781C2.33398 12.0038 2.33398 11.5138 2.33398 10.5337V4.46699C2.33398 3.4869 2.33398 2.99685 2.52472 2.62251C2.6925 2.29323 2.96022 2.02551 3.2895 1.85773C3.66385 1.66699 4.15389 1.66699 5.13398 1.66699H7.00752C7.43555 1.66699 7.64957 1.66699 7.85097 1.71534C8.02954 1.75821 8.20024 1.82892 8.35682 1.92487C8.53342 2.0331 8.68475 2.18443 8.98742 2.48709L10.8472 4.34689C11.1499 4.64956 11.3012 4.80089 11.4094 4.97749C11.5054 5.13407 11.5761 5.30477 11.619 5.48334C11.6673 5.68474 11.6673 5.89876 11.6673 6.32679Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="report-date-text" [class.expanded-text]="isFullScreen">Report Date : {{ (assetReviewStoreDetails?.reportDate || 'N/A') }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Loader Section - Show while loading -->
<div *ngIf="isLoading && !hasError" class="loader-section">
    <div class="loader-content">
      <div class="loader-message">The data is confirmed - we’re generating the report for you.</div>
      <div class="loader-progress-bar">
        <div class="progress-fill" [style.width.%]="loadingProgress"></div>
      </div>
    </div>
  </div>

  <!-- Error Section - Show when there's an error -->
  <div *ngIf="hasError && dataValidation" class="error-section">
    <mtn-analytics-error-state
      (tryAgain)="retryApiCalls()"
      (goBack)="handleGoBack()">
    </mtn-analytics-error-state>
  </div>

  <div *ngIf="(loadingdataValidation < 100) && !dataValidation" class="loader-section">
    <div class="loader-content">
      <div class="loader-message" *ngIf="loadingdataValidation < 100">Kindly hold on while we verify the sales volume data.</div>
      <div class="loader-progress-bar">
        <div class="progress-fill" [style.width.%]="loadingdataValidation"></div>
      </div>
    </div>
  </div>

 <div *ngIf="!dataValidation " class="error-section">
    <mtn-analytics-sales-data-error *ngIf="loadingdataValidation == 100"
      (goBack)="handleGoBack()">
    </mtn-analytics-sales-data-error>
  </div>

  <!-- Content Section - Show when not loading and no errors -->
  <div *ngIf="!isLoading && !hasError && dataValidation">
    <!-- Overall Grade Section -->
    <div class="overall-grade-section" [ngStyle]="{ 'background': getGradeBackground(overallGrade) }">
      <div class="grade-content">
        <div class="grade-display">{{ overallGrade }}</div>
        <div class="grade-label">Overall Store Grade</div>
      </div>
    </div>

    <!-- Performance Cards Section -->
    <div class="performance-cards" [class.expanded]="isFullScreen">
      <!-- Total Sales Performance -->
      <div class="performance-card total-sales">
        <div class="card-header">
          <div class="card-title-section">
            <img src="https://api.builder.io/api/v1/image/assets/TEMP/712a0df69a5090ea88dff1b18988c4e458e04aed" alt="Chart Icon" class="card-icon">
            <h3 class="card-title">Total Sales Performance</h3>
            <svg class="info-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" matTooltip="How well a store meets sales goals or standards." matTooltipClass="custom-tooltip" matTooltipPosition="right">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="#50C878"/>
            </svg>
          </div>
          <div class="grade-badge" [ngStyle]="{ 'background-color': getGradeColor(storePerformanceData?.salesTotalPerformance?.salesTotalGrade), 'color': getGradeTextColor(storePerformanceData?.salesTotalPerformance?.salesTotalGrade) }">{{ getSafeValue(storePerformanceData?.salesTotalPerformance?.salesTotalGrade) }}</div>
        </div>
        <div class="card-content">
          <div class="metric-row">
            <span class="metric-label">Subject Store Annual Sales</span>
            <span class="metric-value annual-sales">{{ formatCurrency(storePerformanceData?.salesTotalPerformance?.annualSalesTotal) }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">vs Trade Area Average  {{ storePerformanceData?.driveTimeMinutes ? '(' + storePerformanceData?.driveTimeMinutes + ' min DT)' : '' }}</span>
            <span class="metric-value" [style.color]="getColorForPercentage(storePerformanceData?.salesTotalPerformance?.vsTradeAreaSalesAverage)">{{ formatPercentage(storePerformanceData?.salesTotalPerformance?.vsTradeAreaSalesAverage) }}
              {{ storePerformanceData?.salesTotalPerformance?.vsTradeAreaSalesAverage > 0 ? '↑' : (storePerformanceData?.salesTotalPerformance?.vsTradeAreaSalesAverage < 0 ? '↓' : '') }}
            </span>
          </div>
          <div class="metric-row margin-top-10">
            <span class="metric-label">vs Banner Market Average</span>
            <span class="metric-value" [style.color]="getColorForPercentage(storePerformanceData?.salesTotalPerformance?.vsBannerMarketSalesAverage)">{{ formatPercentage(storePerformanceData?.salesTotalPerformance?.vsBannerMarketSalesAverage) }}
              {{ storePerformanceData?.salesTotalPerformance?.vsBannerMarketSalesAverage > 0 ? '↑' : (storePerformanceData?.salesTotalPerformance?.vsBannerMarketSalesAverage < 0 ? '↓' : '') }}
            </span>
          </div>
          <div class="metric-row margin-top-10">
            <span class="metric-label">vs Market Average</span>
            <span class="metric-value" [style.color]="getColorForPercentage(storePerformanceData?.salesTotalPerformance?.vsMarketSalesAverage)">{{ formatPercentage(storePerformanceData?.salesTotalPerformance?.vsMarketSalesAverage) }}
              {{ storePerformanceData?.salesTotalPerformance?.vsMarketSalesAverage > 0 ? '↑' : (storePerformanceData?.salesTotalPerformance?.vsMarketSalesAverage < 0 ? '↓' : '') }}
            </span>
          </div>
        </div>
      </div>

      <!-- Sales Per Square Foot -->
      <div class="performance-card sales-sqft">
        <div class="card-header">
          <div class="card-title-section">
            <img src="https://api.builder.io/api/v1/image/assets/TEMP/c20dae3ddabf0d07afe96d6b2b87e14c914cee12" alt="Chart Icon" class="card-icon">
            <h3 class="card-title">Sales Per Square Foot </h3>
            <svg class="info-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" matTooltip="Sales revenue divided by store selling area." matTooltipClass="custom-tooltip" matTooltipPosition="right">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="#50C878"/>
            </svg>
          </div>
          <div class="grade-badge" [ngStyle]="{ 'background-color': getGradeColor(storePerformanceData?.salesPerSqftPerformance?.salesPerSqftGrade), 'color': getGradeTextColor(storePerformanceData?.salesPerSqftPerformance?.salesPerSqftGrade) }">{{ getSafeValue(storePerformanceData?.salesPerSqftPerformance?.salesPerSqftGrade) }}</div>
        </div>
        <div class="card-content">
          <div class="metric-row">
            <span class="metric-label">Subject Store Annual Sales PSF</span>
            <span class="metric-value annual-sales">${{storePerformanceData?.salesPerSqftPerformance?.annualSalesPerSqft}}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">vs Trade Area Average {{ storePerformanceData?.driveTimeMinutes ? '(' + storePerformanceData?.driveTimeMinutes + ' min DT)' : '' }}</span>
            <span class="metric-value" [style.color]="getColorForPercentage(storePerformanceData?.salesPerSqftPerformance?.vsTradeAreaSalesPerSqftAverage)">{{ formatPercentage(storePerformanceData?.salesPerSqftPerformance?.vsTradeAreaSalesPerSqftAverage) }}
              {{ storePerformanceData?.salesPerSqftPerformance?.vsTradeAreaSalesPerSqftAverage > 0 ? '↑' : (storePerformanceData?.salesPerSqftPerformance?.vsTradeAreaSalesPerSqftAverage < 0 ? '↓' : '') }}</span>
          </div>
          <div class="metric-row margin-top-10">
            <span class="metric-label">vs Banner Market Average</span>
            <span class="metric-value" [style.color]="getColorForPercentage(storePerformanceData?.salesPerSqftPerformance?.vsBannerMarketSalesPerSqftAverage)">{{ formatPercentage(storePerformanceData?.salesPerSqftPerformance?.vsBannerMarketSalesPerSqftAverage) }}
              {{ storePerformanceData?.salesPerSqftPerformance?.vsBannerMarketSalesPerSqftAverage > 0 ? '↑' : (storePerformanceData?.salesPerSqftPerformance?.vsBannerMarketSalesPerSqftAverage < 0 ? '↓' : '') }}
            </span>
          </div>
          <div class="metric-row margin-top-10">
            <span class="metric-label">vs Market Average</span>
            <span class="metric-value" [style.color]="getColorForPercentage(storePerformanceData?.salesPerSqftPerformance?.vsMarketSalesPerSqftAverage)">{{ formatPercentage(storePerformanceData?.salesPerSqftPerformance?.vsMarketSalesPerSqftAverage) }}
              {{ storePerformanceData?.salesPerSqftPerformance?.vsMarketSalesPerSqftAverage > 0 ? '↑' : (storePerformanceData?.salesPerSqftPerformance?.vsMarketSalesPerSqftAverage < 0 ? '↓' : '') }}
            </span>
          </div>
        </div>
      </div>

      <!-- Real Estate Quality -->
      <div class="performance-card real-estate">
        <div class="card-header">
          <div class="card-title-section">
            <img src="https://api.builder.io/api/v1/image/assets/TEMP/b608914387b51202a9005e317a3aefd2d03e46bd" alt="Building Icon" class="card-icon">
            <h3 class="card-title">Real Estate Quality</h3>
            <svg class="info-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" matTooltip="Overall condition and appeal of a retail property." matTooltipClass="custom-tooltip" matTooltipPosition="right">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="#50C878"/>
            </svg>
          </div>
          <div class="grade-badge" [ngStyle]="{ 'background-color': getGradeColor(realEstateQualityData?.grade), 'color': getGradeTextColor(realEstateQualityData?.grade) }">{{ getSafeValue(realEstateQualityData?.grade) }}</div>
        </div>
        <div class="card-content">
          <div class="metric-row">
            <span class="metric-label">Access</span>
            <span class="metric-value">{{ getSafeValue(realEstateQualityData?.accessibility) }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">Parking</span>
            <span class="metric-value">{{ getSafeValue(realEstateQualityData?.parking) }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">Visibility</span>
            <span class="metric-value">{{ getSafeValue(realEstateQualityData?.visibility) }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">Traffic Flow</span>
            <span class="metric-value">{{ getSafeValue(realEstateQualityData?.trafficFlow) }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">Shopping Center Condition</span>
            <span class="metric-value">{{ getSafeValue(realEstateQualityData?.scCondition) }}</span>
          </div>
        </div>
      </div>

      <!-- Banner Strength -->
      <div class="performance-card banner-strength">
        <div class="card-header">
          <div class="card-title-section">
            <img src="https://api.builder.io/api/v1/image/assets/TEMP/532b810cb01357adbfd7c142ffc9697f10ab7ba8" alt="Target Icon" class="card-icon">
            <h3 class="card-title">Banner Strength</h3>
            <svg class="info-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                matTooltip="A brand’s market presence and customer loyalty." matTooltipClass="custom-tooltip" matTooltipPosition="right">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="#50C878"/>
            </svg>
          </div>
          <div class="grade-badge" [ngStyle]="{ 'background-color': getGradeColor(bannerStrengthData?.grade), 'color': getGradeTextColor(bannerStrengthData?.grade) }">{{ getSafeValue(bannerStrengthData?.grade) }}</div>
        </div>
        <div class="card-content">
          <div class="metric-row">
            <span class="metric-label">Credit Score</span>
            <span class="metric-value">{{ (bannerStrengthData?.creditRating) || 'N/A' }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">Network Stability</span>
            <span class="metric-value">{{ (bannerStrengthData?.networkStabillity) || 'N/A' }}</span>
          </div>
          <div class="divider"></div>
          <div class="metric-row">
            <span class="metric-label">Market Presence</span>
            <span class="metric-value">{{ (bannerStrengthData?.marketPresence) || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <!-- Competitive Impact -->
      <div class="performance-card competitive-card">
        <div class="card-header">
          <div class="card-title-section">
            <img src="https://api.builder.io/api/v1/image/assets/TEMP/18b0e85057de962f5e399c27cb8db0357a11c1af" alt="Bar Chart Icon" class="card-icon">
            <h3 class="card-title">Competitive Impact {{ getAllCompetitors().length > 0 ? '(' + driveTimeRadiusMinutes + ' min DT)' : '' }} </h3>
            <svg class="info-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" [appHtmlTooltip]="bannerStrengthTooltipHtml"
                matTooltipPosition="right">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="#50C878"/>
            </svg>
          </div>
          <div class="grade-badge" [ngStyle]="{ 'background-color': getGradeColor(competitiveImpactData?.competitiveImpactGrade), 'color': getGradeTextColor(competitiveImpactData?.competitiveImpactGrade) }">{{ getSafeValue(competitiveImpactData?.competitiveImpactGrade, 'N/A') }}</div>
        </div>
        <div class="card-content">
          <ng-container *ngIf="getAllCompetitors().length > 0; else noCompetitors">
            <ng-container *ngFor="let competitor of getVisibleCompetitors(); let i = index">
              <div class="competitor-item">
                <div class="competitor-main">
                  <span class="competitor-name" [class.expanded]="isFullScreen">{{ (competitor?.name) }}</span>
                  <span class="competitor-distance">{{ competitor?.distance }}</span>
                </div>
                <div class="competitor-address" [class.expanded]="isFullScreen">{{ (competitor?.address) }}</div>
              </div>
              <div class="divider" *ngIf="i < getVisibleCompetitors().length - 1"></div>
            </ng-container>
            <div class="see-more" *ngIf="getAllCompetitors().length > maxVisibleCompetitors">
              <a class="see-more-link" (click)="toggleCompetitorList()">
                {{ isCompetitorListExpanded ? 'See Less' : 'See More' }}
              </a>
            </div>
          </ng-container>
          <ng-template #noCompetitors>
            <div class="no-data-message">
              <span class="metric-value">No competitive data available</span>
              <div class="competitor-drive-time" [class.expanded]="isFullScreen"> Drive time : {{driveTimeRadiusMinutes}} min </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Overall Grade Component Breakdown -->
      <div class=" performance-card grade-breakdown-card">
        <div class="grade-breakdown-header" (click)="toggleGradeBreakdown()">
          <div class="header-content">
            <div class="left-section">
              <svg class="chart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 10.5V17.5M11.5 5.5V17.5M16 10.5V17.5M20.5 5.5V17.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div class="title-container">
                <span class="title-text">Overall Grade Component Breakdown</span>
              </div>
            </div>
            <svg class="arrow-icon" [class.expanded]="isGradeBreakdownExpanded" width="31" height="32" viewBox="0 0 31 32" fill="none">
              <path d="M14.996 18.0442L21.5861 11.4541L23.4686 13.3366L14.996 21.8092L6.52344 13.3366L8.40594 11.4541L14.996 18.0442Z" fill="white"/>
            </svg>
          </div>
        </div>
        <div class="breakdown-content-wrapper" [class.expanded]="isGradeBreakdownExpanded">
          <div class="grade-breakdown-chart">
            <!-- Chart content will go here -->
            <mtn-overall-grade-breakdown-chart
              [isExpanded]="isFullScreen"
              [showHeader]="false">
            </mtn-overall-grade-breakdown-chart>
          </div>
        </div>
      </div>
 <div class=" performance-card glossary-card">
        <div class="grade-breakdown-header" (click)="toggleGlossary()">
          <div class="header-content">
            <div class="left-section">
              <!--License: MIT. Made by css.gg: https://github.com/astrit/css.gg-->
             <img src="assets/images/glossary-icon1.png" alt="Glossary" width="24" height="24">

              <div class="title-container">
                <span class="title-text">Glossary</span>
              </div>
            </div>
            <svg class="arrow-icon" [class.expanded]="isGlossaryExpanded" width="31" height="32" viewBox="0 0 31 32" fill="none">
              <path d="M14.996 18.0442L21.5861 11.4541L23.4686 13.3366L14.996 21.8092L6.52344 13.3366L8.40594 11.4541L14.996 18.0442Z" fill="white"/>
            </svg>
          </div>
        </div>
        <div class="breakdown-content-wrapper" [class.expanded]="isGlossaryExpanded">
          <div class="glossary-content">
            <span class="glossary-label">Trade area </span>  - The geographic region around a store defined by drive time (e.g., 5, 7, or 10 mins). It represents the area from which most customers are likely to travel to shop at the store.
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
           <span class="glossary-label" >Trade area average </span> - The average performance of all stores located within the defined trade area. This provides a localized benchmark for comparison.
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
          <span class="glossary-label" >Market area </span> - A broader geography based on the CBSA. A market area typically covers an entire metro region and includes multiple trade
          areas.
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
          <span class="glossary-label" >
            Market average
          </span> - The average performance of all stores within the market area (CBSA). This provides a broad market benchmark for comparison.
          </div>
          <div class="divider-glossary"></div>

           <div class="glossary-content">
            <span class="glossary-label">
              Banner Market average
            </span>
           - The average performance of all stores under the same banner (retail brand) within the market area. This shows how a specific chain is performing compared to the overall market.
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
            <span class="glossary-label" >
              Credit Score
            </span>
           - RetailStat proprietary score reflecting the financial and operational strength of a store or site. Higher scores indicate lower risk and better stability.
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
            <span class="glossary-label">
              Real Estate Quality
            </span>
           - An assessment that balances factors such as Access (an assessment of ingress and egress), Parking conditions and sufficiency, Visibility of the store from the streets, Traffic Flow within the shopping center, and Shopping Center (SC) Condition (which is an assessment of the overall condition of the shopping center, including upkeep, maintenance, and visual appeal).
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
            <span class="glossary-label" >
              Network Stability
            </span>
           - Assessment of a banner's expansion and closure activity over time, indicating operational consistency and market commitment.
          </div>
          <div class="divider-glossary"></div>

          <div class="glossary-content">
            <span class="glossary-label" >
              Market Presence
            </span>
           - The concentration of a banner's stores within the subject market relative to its total network footprint.
          </div>
        </div>
      </div>

      <!-- Download Buttons -->
      <div class="download-buttons">
        <button class="download-pdf-btn" (click)="onDownloadPdf()">Download PDF</button>
        <div class="export-dropdown">
          <button class="export-data-btn" (click)="toggleExportMenu()">
            <span>Export Data</span>
            <svg class="export-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10.3963 11.8492L14.7455 7.5L15.9879 8.74238L10.3963 14.334L4.80469 8.74238L6.04707 7.5L10.3963 11.8492Z" fill="white"/>
            </svg>
          </button>
          <!-- Export Menu (hidden by default) -->
          <div class="export-menu" [class.show]="exportMenuVisible">
            <div class="export-menu-item" (click)="onExportData('csv')">Export as CSV</div>
            <div class="export-menu-item active" (click)="onExportData('excel')">Export as Excel</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
